import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const TargetSetupPage = lazy(() => import("./pages/TargetSetupPage"));
const TargetSetupOverviewPage = lazy(
  () => import("./pages/TargetSetupOverviewPage"),
);

const TARGET_SETUP_NAMESPACES = [
  Feature_NAMESPACES.TARGET_SETUP,
  Feature_NAMESPACES.METRIC_ASSIGNMENT,
];

export const targetSetupRoutes = [
  {
    path: PATHS.TARGET_SETUP,
    element: (
      <FeatureProvider namespace={TARGET_SETUP_NAMESPACES}>
        <TargetSetupPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.TARGET_SETUP_OVERVIEW,
    element: (
      <FeatureProvider namespace={TARGET_SETUP_NAMESPACES}>
        <TargetSetupOverviewPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
];
